import { Ref } from 'vue';

import { createContext } from '@/helpers/create-context';


/**
 * Provide a background color to the app
 *
 * @param string color The background color to provide
 */
export const [
  provideBackgroundColor,
  consumeBackgroundColor,
] = createContext<Ref<string>>('background-color');


